import { AuditEntity } from './AuditEntity';

export interface Report extends AuditEntity {
  date: string; // ISO date
  templateName: string;
  templateId: string; // uuid
  departmentName: string;
  departmentId: string; // uuid
  storeName: string;
  storeId: string; // uuid
  actionSubjectId: string; // uuid
  action: string; // enum
  actionSubject: string;
  amount: number;
}

export enum ReportField {
  STORE_ID = 'storeId',
  STORE_NAME = 'storeName',
  DEPARTMENT_ID = 'departmentId',
  DEPARTMENT_NAME = 'departmentName',
  TEMPLATE_ID = 'templateId',
  TEMPLATE_NAME = 'templateName',
  ACTION = 'action',
  DATE = 'date',
  ACTION_SUBJECT = 'actionSubject',
  AMOUNT = 'amount',
}
